import React from 'react';
import './ErrorBoundary.css';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render shows the fallback UI
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // Log error to an error reporting service
    console.error("Error caught by ErrorBoundary: ", error, errorInfo);
  }

  handleReload = () => {
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="error-page">
          <div className="error-content">
            <h1>Oops! Something Went Wrong</h1>
            <p>We're sorry, but something went wrong. Please try one of the following:</p>
            <ul>
              <li>Reload the page</li>
              <li>Return to the <a href="/">homepage</a></li>
              <li>Contact <a href="mailto:support@example.com">support</a> if the issue persists</li>
            </ul>
            <button onClick={this.handleReload} className="error-button">Reload Page</button>
          </div>
        </div>
      );
    }

    return this.props.children; 
  }
}

export default ErrorBoundary;
